import { render, staticRenderFns } from "./AttendanceRecord.vue?vue&type=template&id=8ca689c2&scoped=true"
import script from "./AttendanceRecord.vue?vue&type=script&lang=js"
export * from "./AttendanceRecord.vue?vue&type=script&lang=js"
import style0 from "./AttendanceRecord.vue?vue&type=style&index=0&id=8ca689c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca689c2",
  null
  
)

export default component.exports